import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {AndroidIcon, IphoneIcon, GameIcon, FlutterIcon, HealthcareIcon, ReactIcon} from "../../../app-constants";
import { Link } from 'gatsby'; // Import Gatsby's Link component


const StackItem = [
    {
        icon: AndroidIcon,
        title: 'Android app development',
        description: (
            <>
                From a creative designer to a full-fledged developer, we provide a seamless experience of working with our mobile app developers Columbus Ohio. If you have an idea in your mind, you can share it with our experts and they will further craft it to make a unique digital solution. You can have your native{' '}
                <Link to="/android-app-development" rel="noopener" aria-label="TekRevol">
                    Android app development services
                </Link> {' '}
                with premium UI/UX based on rich features with seamless functionality.
            </>
        ),
    },
    {
        icon: IphoneIcon,
        title: 'Iphone app development',
        description: (
            <>
                If you want to target specifically the iPhone, you are in the perfect place as we build feature-rich iPhone apps. We transform complex ideas into seamless functions that will enable you to digitize your operations. By understanding the diverse requirements of any business, we ensure a robust{' '}
                <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
                    iPhone app development
                </Link> {' '}
                that will enable you to scale up easily. You can consider us for a complete solution of app development Ohio.
            </>
        ),
    },
    {
        icon: GameIcon,
        title: 'Game app development',
        description: (
            <>
                We ensure to make your game idea real with our efficient app development in Columbus Ohio. With high-quality graphics and deep programming, we build stunning games that will provide a features pack game with a seamless experience. Our expert team of game developers is well aware of the latest trends in the gaming industry and we always remain one step ahead of the competition with our robust stack in our{' '}
                <Link to="/game-development" rel="noopener" aria-label="TekRevol">
                    game development services.
                </Link> {' '}

            </>
        ),
    },
    {
        icon: FlutterIcon,
        title: 'Flutter app development',
        description: (
            <>
                Using Flutter as a full-fledged framework to build feature-rich applications, we can facilitate you with efficient digital solutions for both Android and iOS. You can save big by using{' '}
                <Link to="/flutter-app-development" rel="noopener" aria-label="TekRevol">
                    Flutter app development
                </Link> {' '}
                to build your mobile app due to its cross-platform compatibility. The superfast performance with extensible widgets will leave a lasting impression on the users and that’s what every business wants for its growth.
            </>
        ),
    },
    {
        icon: HealthcareIcon,
        title: 'Healthcare app development',
        description: "Having a proven track record in the healthcare industry, we have expertise in the development of versatile healthcare services. If you want to streamline the complex tasks of your healthcare business, then a mobile app can take you far. It allows you to bring efficiency to the operations and a credible presence in the market. You can rely on our healthcare app development services in Ohio to automate multiple tasks in your healthcare sector.",
    },
    {
        icon: ReactIcon,
        title: 'React Native app development',
        description: (
            <>
                We are well-equipped to utilize{' '}
                <Link to="/react-native-app-development" rel="noopener" aria-label="TekRevol">
                    React native app development
                </Link> {' '}
                to its maximum for achieving extensive functionality with smooth performance. By making the best use of the top-notch functionality of JavaScript with Synchronous API, we offer a native experience for your app. So, you can conduct business operations with a stellar user experience. Hire our React native app developers today, and ignite your app ideas into reality.
            </>
        ),
    },

];

function Improvise(props) {
    return (
        <div className="improvise_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                <Col xs={12} md={12} lg={12} xl={10} xxl={4} className="m-xl-auto m-xxl-0">
                        <h2>Business Empowering Mobile App Development Services In Ohio</h2>
                        <p className="impro_para">Utilizing the proficiency of our mobile app developers in Ohio, we provide tailored solutions according to your business requirements. You can opt for our mobile app development services in Ohio, and as a result get a robust mobile application that will play a vital role in enhancing your overall business presence.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
                        <div className="stack_box">
                            {StackItem.map((item, index) => (
                                <div className="stack_item" key={index}>
                                    <div className="stack_title">
                                        {item.icon}
                                        <h5>{item.title}</h5>
                                    </div>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Improvise;